module.exports = __webpack_public_path__ + "img/Icon_OPQ.df3859fa.svg";